import { IApplicationData } from "../../../model/application-data";
import { IParametersPortalReponse } from "../../../model/base/response/parameters-portal-response";


export type GobalState = {
    applicationData: IApplicationData | undefined;
    parametersPortal: IParametersPortalReponse | undefined;
    error: { statusCode?: number; message: string } | null;
};

export enum ACTION_TYPES {
    setApplicationData = 'setApplicationData',
    setParametersPortal = 'setParametersPortal',
    setError = 'setError',
}

export const GlobalReducer = (state: GobalState, action: any): GobalState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setApplicationData:
            return {
                ...state,
                applicationData: payload,
                error: null,
            };
        case ACTION_TYPES.setParametersPortal:
            return {
                ...state,
                parametersPortal: payload,
                error: null,
            };
        case ACTION_TYPES.setError:
            return {
                ...state,
                error: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}